export default "__VITE_ASSET__a4bc95b2__"